import { create } from 'zustand';
import type { Product } from '@/types/Product.types';

interface SlaylistProductStore {
  slaylistId: number;
  slaylistProducts: Product[];
  setSlaylistId: (id: number) => void;
  setSlaylistProducts: (products: Product[]) => void;
  removeFromSlaylist: (id: number) => void;
  addToSlaylist: (product: Product, index: number) => void;
}

const useSlaylistStore = create<SlaylistProductStore>((set) => ({
  slaylistProducts: [],
  slaylistId: 0,
  setSlaylistProducts: (products) => set({ slaylistProducts: products }),
  setSlaylistId: (id) => set({ slaylistId: id }),
  removeFromSlaylist: (id) =>
    set((state) => ({
      slaylistProducts: state.slaylistProducts.filter((p) => p.id !== id),
    })),
  addToSlaylist: (product, index) =>
    set((state) => {
      const newProducts = [...state.slaylistProducts];
      // Use splice to insert the product at its original index
      newProducts.splice(index, 0, product);
      return { slaylistProducts: newProducts };
    }),
}));

export default useSlaylistStore;
